import LegalSection from './LegalSection';

function PrivacyPage() {
  return (
    <>
      <header className="hero legal-hero">
        <div>
          <p className="eyebrow">Privacy Policy</p>
          <h1>Data Use & Storage</h1>
          <p className="sub">
            This is a pure front-end single page app. Data stays in your browser (localStorage); we do not collect or upload
            personal information. If analytics/ads are added in the future, we will clearly notify and request consent.
          </p>
          <a className="primary" href="#/">
            Back to Home
          </a>
        </div>
      </header>
      <main className="content">
        <LegalSection />
      </main>
    </>
  );
}

export default PrivacyPage;

